import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeRu from '@angular/common/locales/ru';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MessageService, ConfirmationService } from 'primeng/api';
import { NgxPermissionsService, NgxPermissionsModule } from 'ngx-permissions';
import { MonacoEditorModule, NgxMonacoEditorConfig } from 'ngx-monaco-editor-v2';
import { BASE_PATH as BASE_PATH_AUTH } from '@src/api/auth';
import { BASE_PATH as BASE_PATH_V1 } from '@src/api/v1';
import { BASE_PATH as BASE_PATH_V2 } from '@src/api/v2';
import { BASE_PATH as BASE_PATH_REPORTS } from '@src/api/reports';
import { BASE_PATH as BASE_PATH_MESSAGES } from '@src/api/messages';
import { environment } from '@src/environments/environment';
import { TokenInterceptor, ErrorHandlerInterceptor, RetryInterceptor, SessionService } from '@src/app/modules/auth';
import { CaptionPipe, DateDisplayValuePipe } from '@src/app/pipes';

import { routes } from './app.routes';
import { FilterTransferService } from './modules/report-designer';

registerLocaleData(localeRu, 'ru');

const monacoConfig: NgxMonacoEditorConfig = {
  // baseUrl: './assets', // configure base path for monaco editor. Starting with version 8.0.0 it defaults to './assets'. Previous releases default to '/assets'
  defaultOptions: { scrollBeyondLastLine: false }, // pass default options to be used
  onMonacoLoad: () => {
    console.log((<any>window).monaco);
  }, // here monaco object will be available as window.monaco use this function to extend monaco editor functionalities.
  // requireConfig: { preferScriptTags: true } // allows to oweride configuration passed to monacos loader
  // monacoRequire: (<any>window).monacoRequire // pass here monacos require function if you loaded monacos loader (loader.js) yourself
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    MessageService,
    ConfirmationService,
    NgxPermissionsService,
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    importProvidersFrom(MonacoEditorModule.forRoot()),
    // importProvidersFrom(MonacoEditorModule.forRoot(monacoConfig)),
    SessionService,
    FilterTransferService,
    CaptionPipe,
    DateDisplayValuePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: (session: SessionService, filterTransferService: FilterTransferService) => async () => {
        filterTransferService.init();
        return session.init();
      },
      deps: [SessionService, FilterTransferService],
      multi: true,
    },
    {
      provide: BASE_PATH_AUTH,
      useValue: environment.basePaths.auth,
    },
    {
      provide: BASE_PATH_V1,
      useValue: environment.basePaths.v1,
    },
    {
      provide: BASE_PATH_V2,
      useValue: environment.basePaths.v2,
    },
    {
      provide: BASE_PATH_REPORTS,
      useValue: environment.basePaths.reports,
    },
    {
      provide: BASE_PATH_MESSAGES,
      useValue: environment.basePaths.messages,
    },
    { provide: LOCALE_ID, useValue: 'ru' },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true },
  ],
};
